import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { t } from '@lib/translation';
import { SnDialogService } from '@lib/ui/dialog';

import { SnLprReasonGroup } from '../models';

@Injectable({ providedIn: 'root' })
export class SnLprReasonGroupsAPI {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
    private readonly _dialogService: SnDialogService,
  ) {}

  public list(params?: ISnListQueryParameters): Observable<ISnListResponse<SnLprReasonGroup>> {
    return this._httpClient.get('/api/lpr/reasongroups/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((rg) => new SnLprReasonGroup(rg)),
      })),
    );
  }

  public get(id: string): Observable<SnLprReasonGroup> {
    return this._httpClient
      .get(`/api/lpr/reasongroups/${id}/`)
      .pipe(map((response: any) => new SnLprReasonGroup(response)));
  }

  public create(data: any): Observable<SnLprReasonGroup> {
    return this._httpClient
      .post('/api/lpr/reasongroups/', data)
      .pipe(map((response: any) => new SnLprReasonGroup(response)));
  }

  public update(id: string, data: any): Observable<SnLprReasonGroup> {
    return this._httpClient
      .patch(`/api/lpr/reasongroups/${id}/`, data)
      .pipe(map((response: any) => new SnLprReasonGroup(response)));
  }

  public delete(id: string): Observable<Object> {
    return this._dialogService
      .confirm({
        message: t('vehicleIntelligence.hotlist.reasonGroups.deleteConfirmation'),
        confirmButton: {
          text: t('common.delete').toUpperCase(),
          color: 'warn',
        },
      })
      .pipe(
        switchMap(() => this._httpClient.delete(`/api/lpr/reasongroups/${id}/`)),
        tap({
          next: () => this._toastrService.success(t('vehicleIntelligence.hotlist.reasonGroups.deleted')),
          error: () =>
            this._toastrService.error(t('vehicleIntelligence.hotlist.reasonGroups.couldNotDelete')),
        }),
      );
  }
}
